// Iter 37 — Admin Reports.
// Thin wrapper that hard-pins the shared Reports engine to the
// "admin" lens. Mounted under /admin/reports. Sees school-wide
// caseload, compliance, service delivery, schedule coverage, and
// the expanded admin-only Trends section (eligibility-by-month,
// domain-by-month, spike alerts).
import Reports from "@/pages/Reports";

export default function AdminReports() {
  return <Reports lockedLens="admin" />;
}
